import { render, staticRenderFns } from "./ReturnProgress.vue?vue&type=template&id=51b4b650&scoped=true&"
import script from "./ReturnProgress.vue?vue&type=script&lang=js&"
export * from "./ReturnProgress.vue?vue&type=script&lang=js&"
import style0 from "./ReturnProgress.vue?vue&type=style&index=0&id=51b4b650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b4b650",
  null
  
)

export default component.exports